var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-uploader',{attrs:{"multiple":"","before-read":_vm.beforeRead,"after-read":_vm.afterRead,"deletable":true,"delete":_vm.deletefile,"accept":"all"},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d25c700e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadFile/index.vue
// module id = null
// module chunks = 